module.exports = __webpack_public_path__ + "assets/certificate.ca3fc123db5a35626ef4c673922c4aa4.svg";